import { render, staticRenderFns } from "./Aquarell.vue?vue&type=template&id=328be2f6&scoped=true&"
import script from "./Aquarell.vue?vue&type=script&lang=js&"
export * from "./Aquarell.vue?vue&type=script&lang=js&"
import style0 from "./Aquarell.vue?vue&type=style&index=0&id=328be2f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328be2f6",
  null
  
)

export default component.exports